import React from 'react'
import { DualList } from '@softura/customcomponent'
import './Accumulator.scss'

interface IProps {
  canFilter?: any,
  filterPlaceholder?:any,
  options?: any
  value?: any,
  onChange?: any
  moveAll?: any,
}

const AccumulatorContainer = ({ filterPlaceholder = '', canFilter = '', moveAll = '', options = '', value = '', onChange = '' }:IProps) => {
  return (
    <DualList
        options = {options}
        value = {value}
        onChange = {onChange}
        canFilter = {canFilter}
        moveAll = {moveAll}
        filterPlaceholder = {filterPlaceholder}
    />
  )
}

export default AccumulatorContainer
